const defaultUser = {
  id: null,
  name: null,
  email: null,
  picture: null,
  roles: null,
  organisation: null,
  lastTimeActitity: null,
  sellerRef: null,
  sellerType: null,
  customerRef: null,
  customerName: null,
};

const user = (state = defaultUser, action) => {
  switch (action.type) {
    case "SET_USER":
      return {
        ...state,
        organisation: action.user.organisation,
        id: action.user.id,
        name: action.user.name,
        lastname: action.user.lastname,
        firstname: action.user.firstname,
        email: action.user.email,
        picture: action.user.picture,
        roles: action.user.roles,
        sellerRef: action.user.sellerRef,
        sellerType: action.user.sellerType,
        customerRef: action.user.customerRef,
        customerName: action.user.customerName
      };

    case "SET_ORGANISATION":
      return {
        ...state,
        organisation: action.organisation,
      };

    /*//Fait planter le select des tableaux
        case 'SET_ACTIVITY_TIME':
            console.log({ action })
            return {
                ...state,
                lastTimeActitity: action.time
            };
            */

    default:
      return state;
  }
};

module.exports = user;



// WEBPACK FOOTER //
// ./src/services/session/reducer.js